import script from "./DegenLayerLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DegenLayerLabel.vue?vue&type=script&setup=true&lang=ts"

import "./DegenLayerLabel.vue?vue&type=style&index=0&id=a1a6866e&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1a6866e"]])

export default __exports__